module.exports = __webpack_public_path__ + "img/logo_ma_orange.8f3b0be0.svg";